module.exports = __webpack_public_path__ + "static/media/hash.20ef4f5c.svg";